import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../providers/provider';
import './course-player-view';
import './course-player-container';

/**
 * Course Player
 *
 * The `LuaCoursePlayer` component is a custom web component that extends `LitElement`.
 * It serves as a container for a course player, providing a structure for managing
 * and displaying course content.
 *
 * The component's render method returns a template that includes:
 * - `lua-provider`: A context provider that takes the `config` property.
 * - `lua-course-player-container`: A container element for manipulating data.
 * - `lua-course-player-view`: A presentational element for displaying data.
 * - A slot element for inserting custom content.
 *
 * Example usage:
 * ```html
 * <lua-course-player config="your-config-string">
 *   <!-- Custom content here -->
 * </lua-course-player>
 * ```
 */
@customElement('lua-course-player')
export class LuaCoursePlayer extends LitElement {
  /** Configuration string for the course player. */
  @property()
  config: string;

  @property({ attribute: 'reattempt-new-flow' })
  reattemptNewFlow: string;

  override render() {
    return html`<!-- Context -->
      <lua-provider
        .config="${this.config}"
        .extendedConfig="${{ reattemptNewFlow: this.reattemptNewFlow === 'true' }}">
        <!-- Container: manipulate data -->
        <lua-course-player-container>
          <!-- Presentational: display data -->
          <lua-course-player-view>
            <!-- Content -->
            <slot></slot>
          </lua-course-player-view>
        </lua-course-player-container>
      </lua-provider>`;
  }
}
